<template>
            <div
                class="field"
                :class="{ 'has-addons': staticRight }"
                :style="fieldStyle"
            >
                <div
                    class="control"
                    :class="{ 'has-icons-left': isMoney }"
                    :style="controlStyle"
                >
                    <template v-if="loading">
                        <span
                            :id="id"
                            class="input input-loading"
                            :class="inputClass"
                            v-bind="$attrs"
                        >&nbsp;</span>
                    </template>
                    <template v-else>
                        <input
                            v-if="type === 'text' || type === 'email' || type === 'time' || type === 'date' || type === 'password'"
                            :type="computedType"
                            :placeholder="placeholder"
                            :id="id"
                            class="input"
                            :class="inputClass"
                            :value="myValue"
                            v-bind="$attrs"
                            @input="onInput"
                            :disabled="disabled"
                            :readonly="readonly"
                            :name="name"
                            :data-cy="testId"
                            :style="inputStyle"
                            :maxlength="maxlength"
                        >
                        <i
                            v-if="type === 'password' && mayViewPassword"
                            class="far"
                            :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                            style="margin-left: -2em; margin-top: 9px; cursor: pointer; position: relative; z-index: 2; color: #1a6e74;"
                            @click="showPassword = !showPassword"
                        />
                        <i
                            v-if="type !== 'password' && validator && validator.$pending"
                            class="fas fa-spinner fa-spin"
                            style="margin-left: -2em; margin-top: 9px; position: relative; z-index: 2; color: #1a6e74;"
                        />
                        <input
                            v-if="type === 'number'"
                            type="text"
                            :placeholder="placeholder"
                            :id="id"
                            class="input"
                            :class="inputClass"
                            v-bind="$attrs"
                            :value="myValue"
                            @input="onInput"
                            @change="onInput"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            style="text-align: right;"
                            :disabled="disabled"
                            :readonly="readonly"
                            :name="name"
                            :data-cy="testId"
                            :style="inputStyle"
                            :maxlength="maxlength"
                        >
                        <input
                            v-if="type === 'checkbox'"
                            type="checkbox"
                            :id="id"
                            :class="inputClass"
                            :checked="myValue"
                            :value="value"
                            v-bind="$attrs"
                            style="margin-top: 10px"
                            @input="onInput"
                            @change="onInput"
                            :disabled="disabled"
                            :readonly="readonly"
                            :name="name"
                            :data-cy="testId"
                            :style="inputStyle"
                        >
                        <textarea
                            v-if="type === 'textarea'"
                            :placeholder="placeholder"
                            :id="id"
                            class="textarea"
                            :class="inputClass"
                            :value="myValue"
                            v-bind="$attrs"
                            @input="onInput"
                            @change="onInput"
                            :disabled="disabled"
                            :readonly="readonly"
                            :name="name"
                            :style="inputStyle"
                            :data-cy="testId"
                            :maxlength="maxlength"
                        />
                        <div
                            v-if="type === 'div'"
                            :id="id"
                            class="input"
                            :class="inputClass"
                            v-bind="$attrs"
                            :style="inputStyle"
                            v-text="myValue"
                        />

                        <span class="icon is-small is-left" v-if="isMoney">
                            <i class="fas fa-dollar-sign"></i>
                        </span>

                        <span v-if="afterInput" v-html="afterInput" />

                        <p
                            class="help is-info"
                            v-if="Number(maxlength) > 0 && showCharsRemaining"
                            v-html="`${Number(maxlength) - myValue.length} of ${maxlength} characters remaining.`"
                            style="line-height: 1; font-size: 70%;"
                        />
                    </template>
                </div>
                <div class="control" v-if="staticRight">
                    <a class="button is-static">{{ staticRight }}</a>
                </div>
                <p
                    class="help is-info"
                    v-if="info"
                    v-html="info"
                    style="line-height: 1;"
                />
<!--
                <div>
                    maxlength = {{ maxlength }}, myValue.length = {{ myValue.length }}, remaining = {{ Number(maxlength) - myValue.length }}
                </div>
-->
                <p
                    class="help is-danger"
                    v-if="validator && validator.$dirty && validator.$invalid && !validator.$pending"
                    v-html="errorMessage"
                />
            </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
        isMoney: {
            type: Boolean,
            default: false,
        },
        staticRight: {
            type: String,
            default: '',
        },
        inputClass: {
            type: Array,
            default() { return []; },
        },
        value: {
            type: [Number, String, Boolean],
            default: '',
        },
        validator: {
            type: Object,
            default: null,
        },
        info: {
            type: String,
        },
        afterInput: {
            type: String,
        },
        errorCond: {
            type: Boolean,
            default: true,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        fieldStyle: {
            type: String,
            default: '',
        },
        controlStyle: {
            type: String,
            default: '',
        },
        inputStyle: {
            type: String,
            default: '',
        },
        testId: {
            type: String,
            default: '',
        },
        mayViewPassword: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: [Number, String],
        },
        showCharsRemaining: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            myValue: this.value,
            showPassword: false,
        }
    },

    computed: {
        computedType() {
            if (this.type === 'password' && this.mayViewPassword) {
                return this.showPassword ? 'text' : 'password';
            }
            return this.type;
        },
    },

    watch: {
        value(cur, prev) {
            this.myValue = cur;
        },
    },
    methods: {
        onInput($event) {
            this.validator && this.validator.$touch();
            this.myValue = this.type === 'checkbox' ? $event.target.checked : $event.target.value;
            this.$emit('input', this.myValue);
        },
    }
}
</script>

<style>
.autoHeight {
    height: unset;
}
</style>
